<template>
    <div v-loading="listContentLoading">      
      <el-input
        class="search-el"
        size="mini"
        v-model="query.name"
        clearable
        placeholder="请输入名称"
      ></el-input>      
      <el-button type="primary" size="mini" @click="getChannelList()"> 查询</el-button>
      <el-button type="primary" size="mini" @click="toCreate()"> 新建渠道</el-button>

      <el-row>
        <el-table
          v-loading="loading"
          :data="list"
          border
          size="mini"
          :stripe="true"
          style="width: 100%; margin: 20px 0;"
        >
          <el-table-column
            prop="id"
            label="ID"
            align="center"
            min-width="3%"
          ></el-table-column>
          <el-table-column label="渠道名称" align="center" min-width="15%">
            <template slot-scope="{ row }">
              <el-button type="text" size="small" @click="toCreate(row.id, row.name)">
                <div>{{ row.name }}</div>
              </el-button>
            </template>
          </el-table-column>
  
          <el-table-column
            prop="uv"
            label="30天点击uv"
            align="center"
            min-width="8%"
          ></el-table-column>

          <el-table-column
            prop="pv"
            label="30天点击pv"
            align="center"
            min-width="8%"
          ></el-table-column>

          <el-table-column
            prop="paid_order_num"
            label="30天付款笔数"
            align="center"
            min-width="8%"
          ></el-table-column>

          <el-table-column
            prop="paid_amount"
            label="30天付款收入"
            align="center"
            min-width="8%"
          ></el-table-column>
  
          <el-table-column label="操作" align="center" min-width="14%">
            <template slot-scope="{ row }">
              <!-- <el-button type="danger" size="mini" @click="deleteChannel(row.id)">
                删除
              </el-button> -->
  
              <el-button
                size="mini"
                @click="toChannelItemData(row.id)"
              >
                数据
              </el-button>

              <el-button
                size="mini"
                @click="toChannelItem(row.id)"
              >
                推广位
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <div class="block">
          <el-pagination
            background
            @current-change="getChannelList"
            :current-page.sync="query.page"
            :page-size="query.limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-row>
    </div>
  </template>
  
  <script>
  import {
    getChannelList,
    createUpdateChannel,
    deleteChannel,
  } from "@/api/cChannel";
  
  export default {
    data: function () {
      return {
        dialogVisible: false,
        list: [],
        loading: false,
        total: 0,
        query: {
          page: 1,
          limit: 20,
          name: "",
        },
  
        listContentLoading: false,
      };
    },
    created: function () {
      this.getChannelList();
    },
    methods: {
      toChannelItem(id) {
        this.$router.push({
            path: "/channel/itemList",
            query: {
                channel_id: id,
            },
        });
      },
      toChannelItemData(id) {
        this.$router.push({
            path: "/channel/itemData",
            query: {
                channel_id: id,
            },
        });
      },
      toCreate(id = 0, name = '') {
        this.$prompt('请输入渠道名称', '渠道', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: name
        }).then(({ value }) => {
            createUpdateChannel({id: id, name: value})
            .then((response) => {
                if (response.code == 1) {
                    this.$message.success(response.message);
                    this.getChannelList();
                }
            });
        });
      },
  
      getChannelList() {
        this.loading = true;
        getChannelList(this.query).then((response) => {
          this.list = response.data.list;
          this.total = response.data.total;
          this.loading = false;
        });
      },
  
      deleteChannel(id) {
        this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
            deleteChannel({
            id: id,
          }).then((response) => {
            if (response.status == 2000) {
              this.getChannelList();
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        });
      },
    },
    mounted() {},
  };
  </script>
  